import { Component, OnInit, OnDestroy } from '@angular/core';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { BlogpostService } from '../blogpost.service';
import { Blogpost } from '../blogpost';
import { Title } from '@angular/platform-browser';

@Component({
  selector: 'app-blogpost-list',
  templateUrl: './blogpost-list.component.html',
  styleUrls: ['./blogpost-list.component.css']
})
export class BlogpostListComponent implements OnDestroy, OnInit {
  private destroy$ = new Subject<void>();

  title = 'Blogs';
  blogs: Blogpost;
  error: {};

  constructor(
    private titleService: Title,
    private blogpostService: BlogpostService
  ) { }

  ngOnInit() {
    this.titleService.setTitle(this.title);

    this.blogpostService.getBlogs().pipe(takeUntil(this.destroy$)).subscribe(
      (data: Blogpost) => this.blogs = data,
      error => this.error = error
    );
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

}
